
import { defineComponent } from "vue";

export default defineComponent({
  name: "DmeArrow",
  props: {
    diff: {
      type: Number,
      default: 0,
    },
  },
});
